import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setAreaData } from "../../reducers/Area/areaForm.reducer";

export const areaEntrySchema = Joi.object({
  name: Joi.string().required().messages({
    "string.empty": "Area Name is required.",
  }),
  address: Joi.string().allow("", null).optional(),
  location_url: Joi.string().allow("", null).optional(),
  latitude: Joi.string().allow("", null).optional(),
  longitude: Joi.string().allow("", null).optional(),
});

export function useAreaForm({ existingStatus }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(existingStatus === 2 ? 0 : 1);
  const [Id, setId] = useState("");
  const [Name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [LocationURL, seLocationURL] = useState("");
  const [Latitude, setLatitude] = useState("");
  const [Longitude, setLongitude] = useState("");

  const handleDeleteId = useCallback((row) => {
    setId(row.id);
    setName(row.name);
    setAddress(row.address);
    seLocationURL(row.location_url);
    setLatitude(row.latitude);
    setLongitude(row.nalongitudeme);
  }, []);

  const areaEntry = useCallback(
    async ({ name, address, location_url, latitude, longitude }) => {
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        // const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
        const { data } = await apiPost({
          url: Urls.areaAdd(),
          data: {
            name: name,
            address: address,
            location_url: location_url,
            latitude: latitude,
            longitude: longitude,
            status: status_Val,
            insert_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (size(data.id) === 36) {
          enqueueSnackbar("Area Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, dispatch, apiPost, enqueueSnackbar]
  );

  const areaUpdate = useCallback(
    async ({ id, name, address, location_url, latitude, longitude }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.areaUpdate(),
          data: {
            id: id,
            name: name,
            address: address,
            location_url: location_url,
            latitude: latitude,
            longitude: longitude,
            status: status_Val,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("area Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading, status, dispatch, apiPost, enqueueSnackbar]
  );

  const areaDelete = useCallback(async () => {
    //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
    try {
      dispatch(showPageLoader());
      const { data } = await apiPost({
        url: Urls.areaUpdate(),
        data: {
          id: Id,
          name: Name,
          address: address,
          location_url: LocationURL,
          latitude: Latitude,
          longitude: Longitude,
          status: 2,
          update_by: "",
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data.id) === 36) {
        enqueueSnackbar("area Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, [
    dispatch,
    apiPost,
    Id,
    Name,
    address,
    LocationURL,
    Latitude,
    Longitude,
    enqueueSnackbar,
  ]);

  const getAreabyId = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.getareaDatabyId(),
          data: {
            id: id,
          },
        });

        dispatch(setAreaData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading, dispatch, apiPost]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    areaEntrySchema,
    handleStatusComboChange,
    areaEntry,
    areaUpdate,
    getAreabyId,
    areaDelete,
    handleDeleteId,
  };
}
